import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden" data-id="element-71">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-73">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="order-2 lg:order-1" data-id="element-74">
            <span className="inline-block py-1 px-3 rounded-full bg-teal-100 text-teal-900 text-sm font-semibold tracking-wide mb-6" data-id="element-75">
              If you're over 35 and your belly suddenly stopped responding… this
              is for you.
            </span>

            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-teal-900 leading-[1.1] mb-6" data-id="element-76">
              You're eating better. <br data-id="element-77" />
              <span className="text-gold-500 italic" data-id="element-78">Trying harder.</span>
            </h1>

            <p className="text-xl md:text-2xl text-charcoal-800 font-serif mb-8 leading-relaxed" data-id="element-79">
              But the scale barely moves — and your midsection feels softer,
              puffier, and harder to control.
            </p>

            <div className="prose prose-lg text-charcoal-800 mb-10" data-id="element-80">
              <p className="mb-4" data-id="element-81">
                If you're over 35 and your belly suddenly feels like it has its
                own rules… you're not imagining it.
              </p>
              <p className="text-[#0D4A4A]" data-id="element-82">
                You're not doing anything wrong.
                <br data-id="element-83" />
                <br data-id="element-84" />
                Your body just needs a different approach now.
              </p>
            </div>

            <div className="text-center" data-id="element-85">
              <Button onClick={() => document.getElementById('pricing-card')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })} data-id="element-86">
                Start The 21-Day Reset ($6.39)
              </Button>

              <p className="mt-4 text-sm text-charcoal-800 opacity-80" data-id="element-87">
                Instant PDF Download • Secure Checkout
              </p>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-1 lg:order-2 relative" data-id="element-88">
            <div className="relative rounded-lg overflow-hidden shadow-2xl bg-cream-100 p-4 rotate-1 border border-cream-200" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/2TT2H6ZfgVmKGAwptRFpLY/Untitled_design_(70).png" alt="Woman measuring her midsection with a tape measure" className="w-full h-auto rounded shadow-sm" data-id="element-90" />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/5 rounded-lg" data-id="element-91"></div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -z-10 top-10 -right-10 w-64 h-64 bg-teal-100 rounded-full blur-3xl opacity-50" data-id="element-92"></div>
            <div className="absolute -z-10 -bottom-10 -left-10 w-64 h-64 bg-gold-500 rounded-full blur-3xl opacity-20" data-id="element-93"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}